import React from 'react';
import { Button, Tooltip } from 'antd';
import { ButtonTypes, ButtonShapes, notSupportedMessage } from 'common';
import { browserName } from 'common/helpers';
const badBrowser = browserName === 'ie' || browserName === 'edge';
const PrintButton: React.FC<{
  size: 'small' | 'default' | 'large';
  icon: string;
  onClick: () => void;
  disabled?: boolean;
  shape?: 'circle' | 'round' | 'circle-outline';
  type?: 'link' | 'default' | 'ghost' | 'primary' | 'dashed' | 'danger';
  className?: string;
}> = ({
  size,
  icon,
  onClick,
  disabled = false,
  shape = ButtonShapes.ROUND,
  type = ButtonTypes.PRIMARY,
  className = '',
}) => {
  return (
    <>
      {badBrowser ? (
        <Tooltip title={notSupportedMessage}>
          <Button
            type={type}
            shape={shape}
            disabled
            size={size}
            icon={icon}
            onClick={onClick}
            className={className}
          >
            Print
          </Button>
        </Tooltip>
      ) : (
        <Button
          type={type}
          shape={shape}
          disabled={disabled}
          size={size}
          icon={icon}
          onClick={onClick}
          className={className}
        >
          Print
        </Button>
      )}
    </>
  );
};

export default PrintButton;
